import Stack from "@mui/material/Stack";
import Box from "@mui/material/Box";

import {BmRemoveIcon} from "~/components/icons/simpleIcons";
import {designColors} from "~/ui";

import {BmErrorButton, BmErrorButtonProps} from "../../ErrorButton";

export const BmDeleteButton: React.FC<BmErrorButtonProps> = ({children, ...props}) => {
  return (
    <BmErrorButton {...props}>
      <Stack direction="row" spacing={0.5} alignItems="center">
        <Box>{children}</Box>
        <BmRemoveIcon id={`delete-icon`} color={designColors.red_3} />
      </Stack>
    </BmErrorButton>
  );
};
